import NormalGameManager from "../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class weChatIcon extends cc.Component {

    @property(cc.Label)
    label: cc.Label = null;

    @property({type:cc.Node,displayName:"红点"})
    redPoint:cc.Node = null;

    update (dt) { 
        let ary = NormalGameManager._instance.weChatManager.getGameData().peoples;
        let length = 0;
        for(let i =0;i<ary.length;i++){
            if(ary[i].peopleChatLinkQueue.length > 0){
                length ++;
            }
        }
        this.label.string = length.toString(); 
        if(length >0){
            this.onAni();
        }else{
            this.stopAni();
        }
    }


    isAni:boolean = false;

    onAni(){
        if(this.isAni){
            return;
        }
        this.isAni = true;
        this.redPoint.active = true;
        const width = 4;
        let once = cc.tween(this.node)
        .by(0.02, {x: width, y: width})
        .by(0.02, {x: 0, y: -width})
        .by(0.02, {x: -width, y: -width})
        .by(0.02, {x: -width, y: 0})
        .by(0.02, {x: 0, y: width})
        .by(0.02, {x: width, y: 0})
        .delay(1);
        cc.tween(this.node).repeatForever(once).start();
    }

    stopAni(){
        this.redPoint.active = false;
        this.isAni = false;
        cc.Tween.stopAllByTarget(this.node);
    }
}
